import type { CurrentUser } from "../hooks/useAuthRestApi";

/**
 * 管理者権限が必要なページへのアクセス可否を判定する
 * Python Backend: isSystemAdmin フラグで判定
 * TS Backend: organizationId ベースで判定（レガシー互換）
 * @param {CurrentUser | null} user - 現在のユーザー情報
 * @return {boolean} アクセス可能な場合はtrue
 */
export const canAccessAdminPages = (user: CurrentUser | null): boolean => {
  if (!user) return false;

  // ローカル開発環境では常に許可
  if (window.location.hostname === "localhost") {
    return true;
  }

  // Python Backend: isSystemAdmin フラグで判定
  if (user.isSystemAdmin !== undefined) {
    return user.isSystemAdmin;
  }

  // TS Backend (レガシー互換): 特定のorganizationIdを管理者として扱う
  const adminOrganizationIds = [
    "5cbf2941-be8b-4866-a6a9-9cac0b2ac723", // Tech Reis Dev (legacy)
    "323d67dc-1fb7-4931-97fc-263bdb48cf4b", // Tech Reis Prd (legacy)
    "e07d14f3-856d-4e65-8b12-542703d9e718", // Dev tenant (new tenantId)
  ];

  return user.organizationId
    ? adminOrganizationIds.includes(user.organizationId)
    : false;
};

/**
 * システム管理者かどうかを判定する
 * @param {CurrentUser | null} user - 現在のユーザー情報
 * @return {boolean} システム管理者の場合はtrue
 */
export const isSystemAdmin = (user: CurrentUser | null): boolean => {
  return user?.isSystemAdmin === true;
};
